const services = [
  { icon: 'ri-calculator-line', label: 'Contabilidade Completa' },
  { icon: 'ri-file-list-3-line', label: 'Assessoria Fiscal' },
  { icon: 'ri-funds-line', label: 'Planejamento Tributário' },
  { icon: 'ri-search-2-line', label: 'Diagnóstico Fiscal' },
  { icon: 'ri-refresh-line', label: 'Regularização' },
  { icon: 'ri-lightbulb-flash-line', label: 'Apoio à Decisão' },
  { icon: 'ri-building-4-line', label: 'Demandas Societárias' },
  { icon: 'ri-user-3-line', label: 'IRPF' },
  { icon: 'ri-coin-line', label: 'Recuperação de Créditos' },
];

export default function FolderApresentacao() {
  return (
    <div
      className="relative overflow-hidden flex flex-col"
      style={{
        width: '390px',
        height: '693px',
        background: 'linear-gradient(160deg, #0a1a3a 0%, #0f2651 45%, #1a3a6e 100%)',
      }}
    >
      <div
        className="absolute inset-0 bg-cover bg-center opacity-10"
        style={{
          backgroundImage:
            "url('https://public.readdy.ai/ai/img_res/a7e72c1aa7aa6c0f163a0a40886be059.jpg')",
        }}
      />
      <div className="absolute top-0 left-0 w-full h-[3px] bg-gradient-to-r from-[#c9a84c] via-[#e8c96a] to-[#c9a84c]" />
      <div className="absolute top-0 left-0 w-[3px] h-full bg-gradient-to-b from-[#c9a84c] via-[#c9a84c]/30 to-transparent" />
      <div className="absolute top-0 right-0 w-32 h-32 border-t-2 border-r-2 border-[#c9a84c]/30 rounded-bl-full" />
      <div className="absolute bottom-0 left-0 w-24 h-24 border-b-2 border-l-2 border-[#c9a84c]/20 rounded-tr-full" />

      <div className="relative z-10 flex flex-col h-full px-8 py-7">
        <div className="flex items-center justify-between mb-4">
          <div>
            <div className="text-white font-bold text-2xl tracking-tight" style={{ fontFamily: 'Georgia, serif' }}>RCP</div>
            <div className="text-[#c9a84c] text-[9px] font-bold tracking-[0.2em] uppercase mt-0.5">Inteligência Contábil &amp; Tributária</div>
          </div>
          <div className="text-right">
            <div className="text-white/40 text-[8px] tracking-widest uppercase">CRC RS</div>
            <div className="text-[#c9a84c]/70 text-[9px] font-semibold">011307/O-2</div>
          </div>
        </div>

        <div className="w-full h-px bg-gradient-to-r from-[#c9a84c] via-[#c9a84c]/50 to-transparent mb-4" />

        <div className="rounded-lg overflow-hidden mb-4" style={{ height: '155px', flexShrink: 0 }}>
          <img
            src="https://readdy.ai/api/search-image?query=professional%20accountant%20working%20modern%20desk%20laptop%20financial%20charts%20documents%20elegant%20office%20warm%20lighting%20sophisticated%20corporate%20clean%20minimal%20background%20high%20end%20business%20atmosphere%20dark%20wood%20desk&width=1080&height=600&seq=folder-hero-01&orientation=landscape"
            alt="RCP Inteligência Contábil"
            className="w-full h-full object-cover object-top"
          />
        </div>

        <div className="mb-4">
          <div className="flex items-center gap-2 mb-1.5">
            <div className="w-5 h-px bg-[#c9a84c]" />
            <span className="text-[#c9a84c] text-[9px] font-bold tracking-[0.2em] uppercase">A contabilidade com o olhar de quem audita</span>
          </div>
          <h2 className="text-white font-bold leading-tight" style={{ fontSize: '20px', fontFamily: 'Georgia, serif' }}>
            Mais controle.<br />
            Mais clareza.<br />
            <span className="text-[#c9a84c]">Decisões mais seguras.</span>
          </h2>
        </div>

        <p className="text-white/55 text-[10px] leading-relaxed mb-4">
          Combinamos experiência contábil, estratégia fiscal e visão analítica para transformar números em decisões inteligentes para o seu negócio.
        </p>

        <div className="mb-4">
          <div className="text-[#c9a84c] text-[9px] font-bold tracking-[0.2em] uppercase mb-2">Nossos Serviços</div>
          <div className="grid grid-cols-3 gap-1.5">
            {services.map((s) => (
              <div key={s.label} className="flex flex-col items-center gap-1 bg-white/5 border border-[#c9a84c]/20 rounded-md py-1.5 px-1">
                <div className="w-5 h-5 flex items-center justify-center text-[#c9a84c]">
                  <i className={`${s.icon} text-xs`} />
                </div>
                <span className="text-white/65 text-[7px] text-center leading-tight">{s.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-[#c9a84c] rounded-lg px-4 py-2.5 flex items-center justify-between mb-4">
          <div>
            <div className="text-[#0f2651] font-bold text-[10px] uppercase tracking-wide">Diagnóstico Gratuito</div>
            <div className="text-[#0f2651]/70 text-[8px] mt-0.5">Fale com a gente agora</div>
          </div>
          <div className="flex items-center gap-1.5">
            <div className="w-5 h-5 flex items-center justify-center bg-[#0f2651] rounded-full">
              <i className="ri-whatsapp-line text-white text-xs" />
            </div>
            <span className="text-[#0f2651] font-bold text-[10px]">(51) 99100-3410</span>
          </div>
        </div>

        <div className="mt-auto">
          <div className="w-full h-px bg-gradient-to-r from-[#c9a84c]/40 to-transparent mb-2" />
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="flex items-center gap-1 text-white/40 text-[8px]">
                <i className="ri-instagram-line text-[9px]" />
                @inteligenciarcp
              </div>
              <div className="flex items-center gap-1 text-white/40 text-[8px]">
                <i className="ri-global-line text-[9px]" />
                rcpinteligencia.com.br
              </div>
            </div>
            <div className="text-[#c9a84c]/50 text-[7px] font-semibold tracking-widest uppercase">Porto Alegre, RS</div>
          </div>
        </div>
      </div>
    </div>
  );
}
